module.exports = __webpack_public_path__ + "img/00031.17b347be.webp";